<template>
  <v-container fluid class="mt-12 mb-12" :style="'overflow-y: scroll; max-height: 100%;'">
    <v-row>
      <v-col cols="12" class="d-flex justify-center">
        <p :class="'header-text grape-nuts text-center'">
          Witaj w naszej księgarni xD<br/><br/>

Freedom Garden Store to miejsce, działające poza ograniczającym nas systemem.
Stworzone dla wolnych ludzi, oczekujących wysokiej jakości książek :) oraz bezpiecznej obsługi.
Wszystkie zamówienia są w pełni szyfrowane. Tak aby nikt nie wiedział jakiej tematyki książek używasz ;P<br/><br/>

Potrzebujemy jedynie Twój adres email, na który otrzymasz kod odbioru paczki z wybranego przez Ciebie paczkomatu.<br/><br/>

Jeśli potrzebujesz rozszerzonego opisu danej Książki :) napisz do nas na czacie ;)<br/><br/>

Odnośnik na górze ;)<br/><br/>

Osobom poniżej 18 roku życia - wstęp wzbroniony!<br/>
W kontakcie!
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "AboutView",
  components: {},
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Grape+Nuts&display=swap");

.grape-nuts {
  font-family: "Grape Nuts", cursive;
}

.header-text {
  color: black;
  font-size: clamp(1.5rem, 2.5vw, 2rem) !important;
  font-weight: bold;
}

.letter-text {
  color: black;
  font-size: clamp(1.5rem, 2.5vw, 2rem) !important;
  font-weight: bold;
}
</style>
